<script>
  import { SPRITESHEET_URL } from '../../utils/constants.ts';
  import { getSearchURL } from '../../utils/search-query.ts';
  import { RecentSearches } from '../../utils/local-storage.ts';
  import { trackEvent } from '../../utils/umami-events.js';

  let {
    brandOnlyText,
    bothGenericBrandText,
    genericText,
    clearButtonTextTemplate,
    name,
    formalName,
    slug,
    genericSlug,
    htmlName = '',
    htmlFormalName = '',
    lang,
    handleClearButtonClick = undefined,
    dataTestId = 'medication-search-result-tile',
    parentComponent,
    focusCallback = () => {},
    blurCallback = () => {},
    handleCompareMedicationClick = undefined,
  } = $props();

  const clearButtonTextReplacePattern = /{{MEDICATION}}/;
</script>

<div class="relative w-full" data-testid={dataTestId}>
  <button
    onclick={() => {
      trackEvent(`${parentComponent}-drug-search-result-click`, { drug: slug });
      RecentSearches.add({ name, formalName, slug, genericSlug });

      if (parentComponent !== 'compare') {
        window.location.href = getSearchURL({ slug, genericSlug, name, lang });
      } else {
        handleCompareMedicationClick({name, slug});
      }
    }}
    onfocus={() => focusCallback()}
    onblur={() => blurCallback()}
    class="block w-full rounded-sm bg-white text-blue-navy shadow-y-sm pseudo-shadow-tight-hover active:shadow-active"
    aria-label={name}
  >
    <div class="w-full px-3 pt-2 pb-1 flex flex-col items-start">
      <div class="text-base tracking-wider" aria-hidden="true">
        {@html htmlName || name}
      </div>
      <div class="text-sm text-gray-charcoal" aria-hidden="true">
        {@html htmlFormalName || formalName}
      </div>
    </div>
    <div
      class="py-1 text-center text-xs leading-normal tracking-wider font-semibold uppercase rounded-b"
      class:bg-blue-very-light={genericSlug === slug}
      class:text-blue-navy={genericSlug === slug}
      class:bg-gray-pale={genericSlug !== slug}
      class:text-gray-charcoal={genericSlug !== slug}
      aria-hidden="true"
    >
      {#if genericSlug === ''}
        {brandOnlyText}
      {:else if genericSlug === slug}{genericText}{:else}{bothGenericBrandText}{/if}
    </div>
  </button>
  {#if handleClearButtonClick}
    <button
      class="absolute top-0 right-0 w-10 h-14 flex justify-center items-center text-gray-silver hover-hover:hover:text-gray-warm active:text-gray-warm
      focus:text-blue-darkish focus:outline-hidden"
      aria-label={clearButtonTextTemplate.replace(clearButtonTextReplacePattern, name)}
      data-testid="{dataTestId}-clear-button"
      onclick={() => handleClearButtonClick({ name, slug })}
    >
      <svg class="w-4 h-4 fill-current rounded-full" role="presentation">
        <use xlink:href="{SPRITESHEET_URL}clear-x" />
      </svg>
    </button>
  {/if}
</div>
